import { useEffect } from 'react';
import { BACKEND_URL } from '../lib/api';

/**
 * Hook to track page views for analytics
 * @param {string} pageName - Name of the page being viewed (e.g., "landing", "directory", "dashboard")
 */
export const usePageTracking = (pageName) => {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        await fetch(`${BACKEND_URL}/api/analytics/page-view`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: pageName,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent
          })
        });
      } catch (e) {
        // Silent fail - don't break the app for analytics
        console.debug('Page tracking:', e);
      }
    };

    trackPageView();
  }, [pageName]);
};

export default usePageTracking;
